
import { Product } from '~/node_modules/sitisjs/dist/internal/sections/products/models/Product';
import SectionProducts from '~/components/collection/SectionProducts';
import FilterPageBlock from '~/cms/blocks/FilterPageBlock';
import ProductMixin from '~/node_modules/sitis-nuxt/lib/mixins/ProductMixin';

export default {
  name: 'Slug',

  fetch: async function () {
    await this.loadProduct();
    await this.getProductsCollection();
  },

  head: function () {
    const title = this.product?.seo?.title || this.product?.name;
    const description = this.product?.seo?.description || '';

    const meta = [
      {
        name: 'og:title', hid: 'og:title', property: 'og:title', content: title,
      },
      { name: 'description', hid: 'metadescription', content: description },
      {
        name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
      },
    ];
    if (this.isEmptyProducts) {
      meta.push({ name: 'robots', content: 'noindex' });
    }
    console.log('this.isEmptyProducts: ', this.isEmptyProducts);

    return this.$seoMetaHelper({
      title: title,
      description: description,

      meta: meta,
    });
  },

  data: function () {
    return {
      productsSection: [],
      productsRecentlyViewed: [],

      isEmptyProducts: false,
    };
  },

  mixins: [
    ProductMixin,
  ],

  computed: {
    titleH1: function () {
      return this.product?.dynamicFields?.seo_heading || this.product?.name;
    },
    description: function () {
      return '';
    },

    metaDescription: function () {
      return this.product?.seo?.description || '';
    },
    
    breadcrumbs: function () {
      const category = [...(this.product?.categories || [])].pop();

      return [
        { title: 'Главная', path: '/' },
        category?.id > 1 ? { title: category?.name, path: `/catalog/${category?.slug}` } : null,
        { title: this.product?.name, path: this.$route.path },
      ].filter((t) => !!t);
    },

    extensions: function () {
      return ['seo_heading'];
    },

    brandLink: function () {
      const catalogUrl = `/${(this.product?.categories || []).map((t) => t.slug).join('/')}`;
      const brandSlug = (this.product?.brand?.url || '').split('/').pop();
      return `${catalogUrl}/f/brand=${brandSlug}`;
    },
  },

  components: {
    Breadcrumbs: () => import('~/components/UI/Breadcrumbs'),
    SectionProducts,
    FilterPageBlock,
  },

  mounted: async function () {
    await this.getProductsRecentlyViewed();
  },

  methods: {
    getProductsCollection: async function (categories) {
      const productsExpand = [
        'characteristics',
        'options',
        'optionsImages',
        'optionsImages.image',
        'promotions',
        'short_characteristics',
        'sort',
      ].join(',');

      const pageSlug = this.$route.params.slug || this.slug;
      let products = await this.$api.agent.transport
        .get(`products/${pageSlug}/product-set-children?expand=${productsExpand}&per-page=999`)
        .then((res) => res.data)
        .catch((err) => []);
      products = products.map((product) => new Product(product));

      this.isEmptyProducts = Boolean((products || []).length <= 0);

      let diameters = [];
      products.map((product) => {
        const value = (product?.characteristics?.[0]?.characteristics || []).find((t) => t?.slug === 'diameter')?.values?.[0];
        if (!!value && !diameters.find((t) => t?.id === value?.id)) {
          diameters.push(value);
        }
      });
      diameters = diameters.sort((a, b) => {
        if (a.slug > b.slug) {
          return 1;
        }
        if (a.slug < b.slug) {
          return -1;
        }
        return 0;
      });
      if (diameters.length <= 0) {
        this.productsSection = [
          {
            products,
          },
        ];

        return;
      }

      const sections = diameters.map((t) => {
        let productsResult = products.filter((product) => {
          const value = (product?.characteristics?.[0]?.characteristics || []).find((t) => t?.slug === 'diameter')?.values?.[0];
          return Boolean(value?.id === t?.id);
        });
        productsResult = productsResult.sort((a, b) => {
          const aWidth = ((a?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'width')?.values?.[0]?.value || '').replace(/\D+/g, '');
          const bWidth = ((b?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'width')?.values?.[0]?.value || '').replace(/\D+/g, '');
          if (aWidth !== bWidth && aWidth < bWidth) {
            return -1;
          }
          if (aWidth !== bWidth && aWidth > bWidth) {
            return 1;
          }

          const aPcdBoltcount = ((a?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'pcd-boltcount')?.values?.[0]?.value || '').replace(/\D+/g, '');
          const bPcdBoltcount = ((b?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'pcd-boltcount')?.values?.[0]?.value || '').replace(/\D+/g, '');
          if (aPcdBoltcount !== bPcdBoltcount && aPcdBoltcount < bPcdBoltcount) {
            return -1;
          }
          if (aPcdBoltcount !== bPcdBoltcount && aPcdBoltcount > bPcdBoltcount) {
            return 1;
          }

          const aHeight = ((a?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'height')?.values?.[0]?.value || '').replace(/\D+/g, '');
          const bHeight = ((b?.characteristics?.[0]?.characteristics || []).find((t) => t.slug === 'height')?.values?.[0]?.value || '').replace(/\D+/g, '');
          if (aHeight !== bHeight && aHeight < bHeight) {
            return -1;
          }
          if (aHeight !== bHeight && aHeight > bHeight) {
            return 1;
          }

          return 0;
        });

        return {
          ...t,
          products: productsResult,
        };
      });
      this.productsSection = sections;
    },
    getProductsRecentlyViewed: async function () {
      const products = await this.$api.agent.transport.get('/recently-viewed').then((res) => res.data).catch(() => []);
      this.productsRecentlyViewed = products;
    },

    scrollToSection: function (sectionId) {
      const section = document.querySelector(`[data-section-key='section-${sectionId}']`);
      if (!section) {
        return;
      }

      window.scrollTo({
        top: section.offsetTop - 120,
        behavior: 'smooth',
      });
    },
  },
};
